<div class="modal-header">
    <button class="btn-close" (click)="bsModalRef.hide()">
        <span></span>
        <span></span>
    </button>
</div>
<div class="modal-body">
    <div class="container">
        <div class="row">
            <div class="col-xs-12">
                <div class="col-md-6">
                    <h2 class="product-family">{{product.familyName}}</h2>
                    <h1 class="product-name">{{product.name}}</h1>
                </div>
                <div class="col-md-6 noDisplayInMobile">
                    <!-- <button class="add-to-cart btn" (click)="addToBasket()">
                        <i class="flaticon-shopping"></i>
                        <span>Modifer</span>
                    </button> -->
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 col-sm-12">
                <form class="form-horizontal">
                    <div class="col-xs-12">
                        <div class="form-group">
                            <div class="col-xs-12 col-sm-6 text-center" [ngClass]="{loading:!loadAvatar}">
                                <img class="img-product" [src]="product.avatar|absolutePath:'products'"
                                    (load)="loadAvatar=true">
                            </div>
                            <div class="col-xs-12 col-sm-6">
                                <div class="product-infos">
                                    <span class="price" *ngIf="product.sizes?.length>0 && product.size>=0">
                                        {{product.sizes[product.size].price}}€
                                    </span>
                                    <ng-container *ngIf="product.sizes?.length>0 && product.size>=0 && product.level">
                                        <span class="sep"></span>
                                        <span class="nb">{{product.sizes[product.size].size}}</span>
                                        <span class="sep"></span>
                                    </ng-container>
                                </div>
                                <div class="product-quantity vcenter">
                                    <b>Quantité :</b>
                                    <div class="quantity">
                                        <button (click)="incrQty()">+</button>
                                        <p>{{product.qty}}</p>
                                        <button (click)="decrQty()">-</button>
                                    </div>
                                </div>
                                <div class="product-comment">
                                    <label>Commentaire : </label>
                                    <textarea name="comment" [(ngModel)]="product.comment" rows="3"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="row margin">
            <div class="col-xs-12">
                <div class="all">
                    <div class="compositions" *ngIf="product.id && !loading">
                        <!-- <ng-template #compositions> -->
                        <ul class="ul-comp">
                            <li class="gr-li" *ngIf="product.compositions?.length>0">
                                <p class="p-par">Compositions :</p>

                                <div class="row" *ngIf="unavComp>0">
                                    <div class="col-xs-12 unavailableIng">
                                        <p>
                                            <i class="flaticon-exclamation "></i> : Ingredient indisponible pour le
                                            moment
                                        </p>
                                    </div>
                                </div>
                                <div class="col-xs-12" style="float: none;">
                                    <div class="check-group" *ngFor="let comp of product.compositions;let i=index"
                                        id="wTooltipComp{{i}}">
                                        <onoffswitch [(ngModel)]="comp.checked" [label]="comp.text"
                                            [available]="comp.available" placement="bottom"
                                            containerClass="customClass">
                                        </onoffswitch>
                                    </div>
                                </div>
                            </li>
                            <li class="gr-li" *ngIf="product.maxNbrIngOptions>0">
                                <p class="p-par">Options :</p>
                                <div class="row">
                                    <div class="col-md-9 col-sm-6 unavailableIng">
                                        <p *ngIf="unavOpt>0">
                                            <i class="flaticon-exclamation "></i> : Ingredient indisponible pour le
                                            moment
                                        </p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xs-12">
                                        <div class="text-gray">
                                            <label class="ingEl">Choix des options : {{product.maxNbrIngOptions}} max
                                            </label>
                                            <div class="d-flex" style="margin: 0px 0px 10px 0px"
                                                *ngIf="product.obligatoryIngredient.length>0">
                                                <label>Obligatoire :</label>
                                                <label *ngFor="let ing of product.obligatoryIngredient">
                                                    {{ing.category}} : {{ing.maxNbrIngOptions}} ingrédient(s)
                                                </label>
                                                <!-- <ul>
                                                                    <li *ngFor="let ing of product.obligatoryIngredient">
                                                                        {{ing.category}} : {{ing.maxNbrIngOptions}} ingrédient(s)
                                                                    </li>
                                                                </ul> -->
                                            </div>
                                        </div>
                                        <ul>
                                            <li *ngFor="let c of product.optionIngredients|groupByCategory;let i=index">
                                                <div>
                                                    <p class="p-col">{{c.category}} :</p>
                                                    <div class="check-group" *ngFor="let opt of c.elements;let i=index">
                                                        <onoffswitch (change)="changeOption(opt)"
                                                            [(ngModel)]="opt.checked" [label]="opt.text"
                                                            [disabled]="!opt.available || (optChecked==product.maxNbrIngOptions && !opt.checked)"
                                                            [available]="opt.available">
                                                        </onoffswitch>
                                                    </div>
                                                </div>

                                            </li>
                                        </ul>
                                        <!-- <tabset class="ingtab text-center">
                                                            <tab *ngFor="let c of product.optionIngredients|groupByCategory;let i=index"
                                                                [heading]="c.category">
                                                                <div class="check-group" *ngFor="let opt of c.elements;let i=index">
                                                                    <onoffswitch (change)="changeOption(opt)" [(ngModel)]="opt.checked"
                                                                        [label]="opt.text"
                                                                        [disabled]="!opt.available || (optChecked==product.maxNbrIngOptions && !opt.checked)"
                                                                        [available]="opt.available">
                                                                    </onoffswitch>
                                                                </div>
                                                            </tab>
                                                        </tabset> -->
                                    </div>
                                </div>
                            </li>
                            <li class="gr-li" *ngIf="product.hasSupp>0">
                                <p class="p-par">Supplément :</p>
                                <div class="row">
                                    <div class="col-md-9 col-sm-6 unavailableIng">
                                        <p *ngIf="unavSupp>0">
                                            <i class="flaticon-exclamation"></i> : Ingredient indisponible pour le
                                            moment
                                        </p>
                                    </div>
                                </div>
                                <div class="row" class="m-div">
                                    <div class="col-xs-12">
                                        <ul>
                                            <li *ngFor="let c of product.supplements|groupByCategory;let i=index">
                                                <div>
                                                    <p class="p-col">{{c.category}} :</p>
                                                    <div class="check-group"
                                                        *ngFor="let supp of c.elements;let i=index">
                                                        <onoffswitch [(ngModel)]="supp.checked" [label]="supp.text"
                                                            [available]="supp.available">
                                                        </onoffswitch>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                        <!-- <tabset class="ingtab">
                                                            <tab *ngFor="let c of product.supplements|groupByCategory;let i=index"
                                                                [heading]="c.category">
                                                                <div class="check-group" *ngFor="let supp of c.elements;let i=index">
                                                                    <onoffswitch [(ngModel)]="supp.checked" [label]="supp.text"
                                                                        [available]="supp.available">
                                                                    </onoffswitch>
                                                                </div>
                                                            </tab>
                                            </tabset> -->
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <!-- </ng-template> -->
                    </div>
                </div>
                <!-- <panel-switch *ngIf="product.id" theme="theme1">
                    <panel *ngIf="product.compositions?.length>0" label="Compositions" id="compositions"
                        [content]="compositions">
                        <ng-template #compositions>
                            <div class="row" *ngIf="unavComp>0">
                                <div class="col-xs-12 unavailableIng">
                                    <p>
                                        <i class="flaticon-exclamation "></i> : Ingredient indisponible pour le moment
                                    </p>
                                </div>
                            </div>
                            <div class="col-xs-12 text-center">
                                <div class="check-group" *ngFor="let comp of product.compositions;let i=index"
                                    [id]="'wTooltipComp'+i">
                                    <ng-template #tolTemplate>
                                        <img *ngIf="comp.avatar" [src]="comp.avatar|absolutePath:'ingredients'"
                                            border="0" width="150" heigth="150">
                                    </ng-template>
                                    <onoffswitch [(ngModel)]="comp.checked" [label]="comp.text"
                                        [available]="comp.available" [tooltip]="tolTemplate" [placement]="bottom"
                                        containerClass="customClass">
                                    </onoffswitch>
                                </div>
                            </div>
                        </ng-template>
                    </panel>
                    <panel *ngIf="product.maxNbrIngOptions>0" label="Options ({{product.maxNbrIngOptions}} max)"
                        id="Options" [content]="options">
                        <ng-template #options>
                            <div class="row">
                                <div class="col-xs-9 unavailableIng">
                                    <p *ngIf="unavOpt>0">
                                        <i class="flaticon-exclamation "></i> : Ingredient indisponible pour le moment
                                    </p>
                                </div>
                                <div class="col-xs-3 search text-right">
                                    <input type="text" name="search" [(ngModel)]="filterOpt" placeholder="Rechercher..."
                                        class="form-control filter input-sm input-small input-inline">
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xs-12 text-center">
                                    <div class="check-group"
                                        *ngFor="let opt of product.optionIngredients|filterIng:filterOpt;let i=index"
                                        [id]="'wTooltipOpt'+i">
                                        <ng-template #tolTemplate>
                                            <img *ngIf="opt.avatar" [src]="opt.avatar|absolutePath:'ingredients'"
                                                border="0" width="150" heigth="150">
                                        </ng-template>
                                        <onoffswitch (change)="changeOption(opt)" [(ngModel)]="opt.checked"
                                            [label]="opt.text"
                                            [disabled]="!opt.available || (optChecked==product.maxNbrIngOptions && !opt.checked)"
                                            [available]="opt.available" [tooltip]="tolTemplate" [placement]="bottom"
                                            containerClass="customClass">
                                        </onoffswitch>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </panel>
                    <panel *ngIf="product.hasSupp>0" id="supplements" label="Supplements" [content]="supplements">
                        <ng-template #supplements>
                            <div class="row">
                                <div class="col-xs-9 unavailableIng">
                                    <p *ngIf="unavSupp>0">
                                        <i class="flaticon-exclamation"></i> : Ingredient indisponible pour le moment
                                    </p>
                                </div>
                                <div class="col-xs-3 search text-right">
                                    <input type="text" name="search" [(ngModel)]="filterSupp"
                                        placeholder="Rechercher..."
                                        class="form-control filter input-sm input-small input-inline">
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xs-12 text-center">
                                    <div class="check-group"
                                        *ngFor="let supp of product.supplements|filterIng:filterSupp;let i=index"
                                        [id]="'wTooltipSupp'+i">
                                        <ng-template #tolTemplate>
                                            <img *ngIf="supp.avatar" [src]="supp.avatar|absolutePath:'ingredients'"
                                                border="0" width="150" heigth="150">
                                        </ng-template>
                                        <onoffswitch [label]="supp.text" [(ngModel)]="supp.checked"
                                            [available]="supp.available" [tooltip]="tolTemplate" [placement]="bottom"
                                            containerClass="customClass"></onoffswitch>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </panel>
                </panel-switch> -->
            </div>
        </div>
    </div>
    <button class="add-to-cart btn" (click)="addToBasket()">
        <i class="flaticon-shopping"></i>
        <span>Modifer</span>
    </button>
</div>